import { BaseEdge, getBezierPath } from '@xyflow/react';

export function edgeStrokeStyle(selected) {
  return selected ? { stroke: '#3d4756', strokeWidth: 1.5 } : { stroke: '#9aa3af', strokeWidth: 1 };
}

export function bhMarkerEnd(selected) {
  return `url(#${selected ? 'bh-edge-arrow-selected' : 'bh-edge-arrow'})`;
}

export function BhEdgeMarkers() {
  const markers = [
    { id: 'bh-edge-arrow', color: '#9aa3af' },
    { id: 'bh-edge-arrow-selected', color: '#3d4756' },
  ];
  return (
    <svg style={{ position: 'absolute', width: 0, height: 0 }} aria-hidden="true">
      <defs>
        {markers.map(m => (
          <marker key={m.id} id={m.id} markerWidth="11.2" markerHeight="5.6" viewBox="0 0 16 8"
            orient="auto" refX="16" refY="4" markerUnits="userSpaceOnUse">
            <path d="M0,0 L16,4 L0,8 Z" fill={m.color} />
          </marker>
        ))}
      </defs>
    </svg>
  );
}

export default function BhFlowEdge({
  sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition, selected, data, label,
}) {
  const [path, labelX, labelY] = getBezierPath({
    sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition,
  });
  return (
    <BaseEdge
      path={path}
      label={label}
      labelX={labelX}
      labelY={labelY}
      markerEnd={bhMarkerEnd(selected)}
      style={edgeStrokeStyle(selected)}
      labelStyle={{ fill: selected ? '#3d4756' : '#9aa3af' }}
    />
  );
}
